import React, { useEffect, useRef } from 'react';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

const MapGta = ({ setMapObject, mini, mapType }) => {
    const mapContainerRef = useRef(null);
    const mapRef = useRef(null);

    const getMapStyle = (mapType) => ({
        version: 8,
        sources: {
            gtaMap: {
                type: 'raster',
                tiles: [
                    `maps/${mapType}/{z}/{x}/{y}.${mapType !== 'road' ? 'jpg' : 'png'}`,
                ],
                tileSize: 256,
            },
        },
        layers: [
            {
                id: mapType,
                type: 'raster',
                source: 'gtaMap',
                minzoom: 0,
                maxzoom: 5,
            },
        ],
    });

    useEffect(() => {
        if (!mapContainerRef.current) return;
        if (!mapRef.current) {
            mapRef.current = new maplibregl.Map({
                container: mapContainerRef.current,
                style: getMapStyle(mapType),
                center: [0, 0],
                zoom: 1,
                minZoom: 0,
                maxZoom: 4.99,
                hash: true,
            });
            setMapObject(mapRef.current);
            mapRef.current.on('load', () => {
                mapRef.current.resize();
            });
        } else {
            mapRef.current.setStyle(getMapStyle(mapType));
        }
    }, [mapType]);

    return (
        <div
            ref={mapContainerRef}
            className='map'
            id='map'
            style={{ width: '100%', height: mini ? '50vh' : '100vh' }}
        ></div>
    );
};

export default MapGta;
